export const emptyInvoiceBrandingForm = {
  name: "",
  invoice_title: "INVOICE",
  tax_invoice_title: "TAX INVOICE",
  proforma_invoice_title: "PROFORMA INVOICE",
  receipt_title: "RECEIPT",
  credit_note_title: "CREDIT NOTE",
  debit_note_title: "DEBIT NOTE",
  refund_receipt_title: "REFUND RECEIPT",
  statement_title: "STATEMENT OF ACCOUNT",
  contact_details: "",
  payment_advice: "",
  terms_conditions: "",
};

export const invoiceBrandingTitleFields = [
  { key: "invoice_title", label: "Invoice title" },
  { key: "tax_invoice_title", label: "Tax invoice title" },
  { key: "proforma_invoice_title", label: "Proforma invoice title" },
  { key: "receipt_title", label: "Receipt title" },
  { key: "credit_note_title", label: "Credit note title" },
  { key: "debit_note_title", label: "Debit note title" },
  { key: "refund_receipt_title", label: "Refund receipt title" },
  { key: "statement_title", label: "Statement title" },
];

export const invoiceBrandingRequiredFields = [
  { key: "name", label: "Name" },
  ...invoiceBrandingTitleFields,
  { key: "contact_details", label: "Company details" },
  { key: "payment_advice", label: "Payment advice" },
  { key: "terms_conditions", label: "Terms & conditions" },
];

export const mapRowToInvoiceBrandingForm = (row = {}) => ({
  name: row.name ?? "",
  invoice_title: row.invoice_title ?? "INVOICE",
  tax_invoice_title: row.tax_invoice_title ?? "TAX INVOICE",
  proforma_invoice_title: row.proforma_invoice_title ?? "PROFORMA INVOICE",
  receipt_title: row.receipt_title ?? "RECEIPT",
  credit_note_title: row.credit_note_title ?? "CREDIT NOTE",
  debit_note_title: row.debit_note_title ?? "DEBIT NOTE",
  refund_receipt_title: row.refund_receipt_title ?? "REFUND RECEIPT",
  statement_title: row.statement_title ?? "STATEMENT OF ACCOUNT",
  contact_details: row.contact_details ?? "",
  payment_advice: row.payment_advice ?? "",
  terms_conditions: row.terms_conditions ?? "",
});

export const buildInvoiceBrandingPayload = (formData) => ({
  name: formData.name.trim(),
  invoice_title: formData.invoice_title.trim(),
  tax_invoice_title: formData.tax_invoice_title.trim(),
  proforma_invoice_title: formData.proforma_invoice_title.trim(),
  receipt_title: formData.receipt_title.trim(),
  credit_note_title: formData.credit_note_title.trim(),
  debit_note_title: formData.debit_note_title.trim(),
  refund_receipt_title: formData.refund_receipt_title.trim(),
  statement_title: formData.statement_title.trim(),
  contact_details: formData.contact_details.trim(),
  payment_advice: formData.payment_advice.trim(),
  terms_conditions: formData.terms_conditions.trim(),
});

export const normalizeInvoiceBrandingList = (response) => {
  const payload = response?.data?.data;

  if (Array.isArray(payload)) {
    return payload;
  }

  if (payload && Array.isArray(payload.data)) {
    return payload.data;
  }

  if (payload && typeof payload === "object") {
    return [payload];
  }

  return [];
};

export {
  isInvoiceSettingApiSuccess as isInvoiceBrandingApiSuccess,
  getInvoiceSettingApiMessage as getInvoiceBrandingApiMessage,
} from "./invoiceSettingHelpers";
